import React from 'react'
import useAutocomplete from '../../../../hooks/useAutocomplete'
import { ApiConfig } from '../../../../config/api'
import { Position } from '../../../../interfaces/Position/Position'
import { AutoCompleter } from '../../../AutoCompleter/AutoCompleter'

interface PositionAutocompleteProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  positionValue: string
  positionNameList?: string
  variant?: 'outlined' | 'standard' | 'filled'
  fullWidth?: boolean
  size?: 'small' | 'medium'
}

export const PositionAutocomplete: React.FC<PositionAutocompleteProps> = ({
  handleChange,
  positionValue,
  positionNameList = 'positionCode',
  variant = 'standard',
  fullWidth = false,
  size = 'small'
}) => {
  const { data: posiciones, loader: loaderPosiciones } =
    useAutocomplete<Position>(
      positionValue,
      `${ApiConfig.PositionApi}/GetByCodeOrName?position=${positionValue}`,
      3
    )
  return (
    <AutoCompleter
      item={posiciones.map((item: any) => {
        return {
          value: item.positionCode
        }
      })}
      nameList={positionNameList}
      labelList={'Código Posición'}
      handleChange={handleChange}
      isLoader={loaderPosiciones}
      value={positionValue}
      variant={variant}
      fullWidth={fullWidth}
      size={size}
    />
  )
}
